import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const DotnetColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M22 2H2V22H22V2Z" fill="#512BD4" />
    <path
      d="M5.56464 14.7778C5.42323 14.7778 5.30303 14.7307 5.20404 14.6364C5.10504 14.5397 5.05555 14.425 5.05555 14.2921C5.05555 14.1567 5.10504 14.0407 5.20404 13.9441C5.30303 13.8474 5.42323 13.7991 5.56464 13.7991C5.70841 13.7991 5.82979 13.8474 5.92879 13.9441C6.03013 14.0407 6.08081 14.1567 6.08081 14.2921C6.08081 14.425 6.03013 14.5397 5.92879 14.6364C5.82979 14.7307 5.70841 14.7778 5.56464 14.7778Z"
      fill="white"
    />
    <path
      d="M11.2179 14.698H10.2986L7.87693 10.8775C7.81566 10.7808 7.76496 10.6805 7.72491 10.5766H7.70368C7.72254 10.6878 7.73197 10.9258 7.73197 11.2907V14.698H6.91882V9.5H7.89811L10.2386 13.23C10.3375 13.3846 10.4012 13.491 10.4295 13.5489H10.4436C10.42 13.4112 10.4082 13.178 10.4082 12.8493V9.5H11.2179V14.698Z"
      fill="white"
    />
    <path
      d="M15.1776 14.698H12.3316V9.5H15.0645V10.2322H13.1731V11.7039H14.916V12.4325H13.1731V13.9694H15.1776V14.698Z"
      fill="white"
    />
    <path d="M19.2222 10.2322H17.7657V14.698H16.9242V10.2322H15.4712V9.5H19.2222V10.2322Z" fill="white" />
  </Icon>
));

export default DotnetColor;
